/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import {
	Card, CardImg, CardText, CardBody,
	CardTitle, Breadcrumb, BreadcrumbItem, Button, Modal, ModalHeader, ModalBody, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm, Errors } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';
import loadsStore from '../../../stores/loads-store';
import JmpModal from './customModal';
import Fuse from "fuse.js";
import ReactDOM from 'react-dom';
import { DropTarget, DragSource } from 'react-dnd';

const Types = {
	ITEM: 'JUMP'
};

const itemSource = {
	beginDrag(props) {
		//console.log('dragging');
		const item = props
		return item
	},
	endDrag(props, monitor, component) {
		//console.log('endrag')
		if (!monitor.didDrop()) {
			return;
		}
		//return props.handleJumperDrop(props)
		return props;
	}
}

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging()
	}
}

class EditableFunJumper extends Component {

	constructor(props) {

		super(props);
		//this.toggleModal = this.toggleModal.bind(this);
		//this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			isModalOpen: false,
			jumpType: null,
			load: props.load,
			jumper: props.jumper,
			type: props.type,
			label: props.type,
			jumpId: props.jumpId,
			editMode: props.editMode,
			menuPlacement: "bottom",
			options: []
		};
		this.gearIds = [];
		this.valRef = null;
		this.inputValue = '';
		this.fuse = undefined;
	}


		componentDidMount = () => {
			if (this.valRef !== null)
				this.valRef.focus();
			var jumperOptions = jumpersStore.getJumperOptions();
			if(this.props.activeJumperIdsOnLoad){
				jumperOptions = jumperOptions.filter(
					option =>
						this.props.activeJumperIdsOnLoad.findIndex(
							id => option.value._id === id
						) === -1
				);
			}
			this.setState({options: jumperOptions});
			this.setFuse(jumperOptions);
		}

	setFuse = (jumperOptions) => {
		var options = {
			shouldSort: true,
			tokenize: true,
			threshold: 0.1,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 2,
			keys: [
				"value.manifestNumber",
				"value.nickname",
				"value.lastname"
			]
		};

		this.fuse = new Fuse(jumperOptions, options); // "list" is the item array
	}

	componentDidUpdate = () => {
		if (this.valRef !== null)
			this.valRef.focus();
			var jumperOptions = jumpersStore.getJumperOptions();
			if(this.props.activeJumperIdsOnLoad){
				jumperOptions = jumperOptions.filter(
					option =>
						this.props.activeJumperIdsOnLoad.findIndex(
							id => option.value._id === id
						) === -1
				);
			}
			this.setFuse(jumperOptions);
	}
	updateGear = (value) => {
		//console.log(value);
		//console.log(value.target);

		var id = value.target.name.substr(4);

		if (value.target.checked) {
			this.gearIds.push(id);
		}
		else {
			this.gearIds = this.gearIds.filter(gearId => gearId !== id);
		}
		//console.log(this.gearIds);
	}

	Option = (props) => {
		var gearModel = ".gear" + props.data.value._id;
		var name = "gear" + props.data.value._id
		return (
			<div className="row">
				<div className="col-8">
					<components.Option {...props} />
				</div>
				<div className="col-4" style={{ paddingTop: '6px' }}>
					gear <Control.checkbox model={gearModel} name={name} onChange={value => { this.updateGear(value) }} />
				</div>
			</div>
		);
	}

	SingleValueLabel = ({ children, ...props }) => {
		//console.log(props);
		//console.log(props.data);
		//console.log(components.SingleValue);
		return (

			<components.SingleValue {...props}><div className="row"> <div className="col-12">{children}</div>{this.gearIds.indexOf(props.data.value._id) > -1 ? <div className="col-12">-G</div> : null}</div></components.SingleValue>
			//{this.gearIds.indexOf(props.data.value._id)>-1?<div className="col-4">-G</div>:null }
		);
	}


	handleChange = (selectedOption, loadNum, jumpId, type, label) => {
		//alert('handle change');
		//console.log("in handle submit for edit jumps");
		// alert('in handle submit fun jumper ' + label + " type : " + type);
		this.setState({ editMode: !this.state.editMode })
		if (selectedOption.value !== undefined) {
			if (type === "coach") {
				if (label === "J") {
					var jumpPostBody = { jumperId: selectedOption.value._id };
					loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
				}
			}
		}
		//this.cancelOrSubmit();
		//clearTimeout(this.timerId);
		// this.timerId = setTimeout(this.cancelOrSubmit(selectedOption, loadNum, jumpId, type,label), 5000);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000);
	}

	changeJumper = () => {
		//alert('change jumper');
		//console.log(this.valRef);
		this.setState({
			editMode: true
		});

		if (ReactDOM.findDOMNode(this).getBoundingClientRect().y > window.innerHeight / 2) {
			this.setState({ menuPlacement: "top" });
		}
		else {
			this.setState({ menuPlacement: "bottom" });
		}
	}

	filterJumpers = (inputValue, jumperOptions) => {
		//console.log("in filterJumpers");
		if (inputValue) {
			//console.log(inputValue);
			/*
			var filteredOptions = jumperOptions.filter(i =>
							i.label.toLowerCase().match(inputValue.toLowerCase()));*/
			//console.log('before useing fuse');
			//var test = jumpersStore.test();
			var filteredOptions = this.fuse.search(inputValue.toLowerCase());
			//alert('after fuse');
			//console.log(filteredOptions);
			if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
			else return filteredOptions;
		}
		return jumperOptions;
	};

	promiseOptions = (inputValue, jumperOptions) => {
		//console.log('in pomiseOptions');
		//console.log(this.state.inputValue);
		return new Promise(resolve => {
			resolve(this.filterJumpers(this.inputValue, jumperOptions));
		});
	}

	handleInputChange = (newValue) => {
		//console.log('handleInputChange');
		//clearTimeout(this.timerId);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000);
		//const inputValue = newValue.replace(/\W/g, '');
		////console.log(inputValue);

		//console.log(newValue);
		//this.promiseOptions(newValue, jumperOptions);
		this.inputValue = newValue;
		this.valRef.focus();
	};

	onBlur = () => {
		this.setState({ editMode: false });
	}

	render() {
		const { isDragging, connectDragSource } = this.props;
		const opacity = isDragging ? 0 : 1;
		var jumperOptions = this.state.options;
		if(this.props.activeJumperIdsOnLoad){
			jumperOptions = jumperOptions.filter(
				option =>
					this.props.activeJumperIdsOnLoad.findIndex(
						id => option.value._id === id
					) === -1
			);
		}
		let SelectInput = (props) => (<Select model={props.model} name={props.name} placeholder={props.placeholder} options={props.options} onChange={props.onChange} isMulti={props.isMulti} components={props.components} styles={props.styles} theme={(theme) => ({
			...theme,
			colors: {
				...theme.colors,
				primary: '#E7F2F6',
				// primary75: 'red',
				// primary50: 'blue',
				primary25: 'blue', // hover option
				// danger: 'green',
				dangerLight: '#59C5DC', // cross background
				neutral0: 'rgb(0, 65, 157)', // background container
				// neutral5: 'pink',
				neutral10: 'blue', // selected option background
				neutral20: '#E7F2F6', // border input without hover
				neutral30: '#E7F2F6', // border input with hover
				neutral40: 'orange',
				neutral50: '#E7F2F6', // default text
				neutral60: '#E7F2F6', // down icon
				neutral70: 'yellow',
				neutral80: '#E7F2F6', //selected text color
				// neutral90: 'rgb(0, 65, 157)',
			},
		})} />);

		// return(
		return connectDragSource(
		
			<div>
				<React.Fragment>
					{!this.state.editMode ?
						
						<div className={'name-container'}   onClick={() => this.changeJumper(this.props.isCompleted)} disabled={this.props.disabled}>
							<span className="tandem-font-size">{this.props.label}</span>
							:
							<strong className="tandem-font-size">
								{this.props.jumper.nickname}&nbsp;
								{this.props.jumper.lastname !== undefined && this.props.jumper.lastname !== "" ? this.props.jumper.lastname.substr(0, 1) : null}
							</strong>
							<div className="memberId tandem-font-size">
								<span className="inline-Id-and-gear" >
									{this.props.jumper.memberId}
								</span>
							</div>
						</div>
						:
						<button className="btn editable-FunJumper" type="submit" disabled={this.props.disabled} style={{ width: '170px' }}>
							<LocalForm form="addjumpers" model="addjumpers" getDispatch={dispatch => this.formDispatch = dispatch} >
								<AsyncSelect model=".jumper" name="jumper" ref={(value) => this.valRef = value} loadOptions={(newValue) => this.promiseOptions(newValue, jumperOptions)}
									defaultOptions={jumperOptions.slice(0, 10)}
									onInputChange={(newValue) => this.handleInputChange(newValue)}
									onChange={(selectedOption) => this.handleChange(selectedOption, this.props.loadNum, this.props.jumpId, this.props.type, this.props.label)} onInputChange={(newValue) => this.handleInputChange(newValue)}
									menuPortalTarget={document.body}
									menuPosition="absolute"
									menuPlacement={this.state.menuPlacement}
									onBlur={this.onBlur}
								/>
							</LocalForm>
						</button>
					}
				</React.Fragment>
			</div>
		);
	}
}

//export default EditableFunJumper
export default DragSource(Types.ITEM, itemSource, collect)(EditableFunJumper)
